export default {
  OPEN_DOCUMENT: 1,
  OPEN_INVITATION: 2,
};
